import {
    Fragment,
    useRef,
    useState,
    useContext,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react';
import { UserContext } from '../../context/UserContext';
import { APIInviteNewUserToCompany } from '../../api/user/User';
import {TfiClose} from "react-icons/tfi";

export const GrantAccessToCompany = ({ show, setShow, company, getAssociates }) => {
    const { user } = useContext(UserContext);
    const cancelButtonRef = useRef(null);
    const [email, setEmail] = useState('');

    const navigate = useNavigate();

    const addNewUserToCompany = async () => {
        const newUser = {
            companyId: user.companyId,
            email: email,
        };


        try {
            if (email === '' || email === null) {
                return;
            }
            
            await APIInviteNewUserToCompany(newUser);

            // Reset the form fields
            setEmail('');

            // Close the dialog
            getAssociates();
            setShow(false);
        } catch (error) {
            console.error('Error adding new user to company:', error);
        }
        
    };

    return (
        <Transition.Root show={show} as={Fragment}>
            <Dialog
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setShow}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >

                            <Dialog.Panel className='flex max-w-2xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative' >

                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => setShow(false)}
                                    ref={cancelButtonRef}
                                >
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='flex w-full h-full'>
                                    <div className={' flex flex-col w-full'}>
                                        <Dialog.Title
                                            as='h3'
                                            className='pt-8 px-8  font-bold text-2xl leading-6 text-gray-900-'>
                                            Zugriff erteilen
                                        </Dialog.Title>
                                        <div className='p-8 flex flex-col flex-1 overflow-y-auto'>
                                            <p className={"text-sm pb-3"}>Sie können hier weiteren Nutzern oder Gemeinden Zugriff zum Account <span className='font-bold'>{company.name}</span> erteilen. Diese erhalten somit Zugriff auf alle im Account befindlichen Pläne wir auch Aufträge.</p>
                                            <p className={"text-sm"}>Sobald Sie einen Kollege:in eingeladen haben erhält dieser/e eine Benachrichtigung an die von Ihnen angegebene E-Mail-Adresse.</p>
                                            <div className=" w-full mt-4">
                                                <label
                                                    htmlFor="email"
                                                    className="text-sm mt-6 mb-2 font-semibold leading-6 text-gray-900"
                                                >
                                                    E-Mailadresse
                                                </label>
                                                <div className="mt-2">
                                                    <input
                                                        id="email"
                                                        name="email"
                                                        type="email"
                                                        value={email}
                                                        onChange={(e) => {
                                                            setEmail(e.target.value);
                                                        }}
                                                        className="block w-full rounded-md border-0 p-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-8 pt-0 sm:flex-row-reverse justify-between flex w-full flex-col-reverse gap-4">
                                            <button
                                                type="button"
                                                className={"text-center truncate items-center rounded-md bg-white text-gray-900  border-gray-900 border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"}
                                                onClick={() => {
                                                    addNewUserToCompany();
                                                }}
                                            >
                                                Einladen
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>

                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
